module.exports = __webpack_public_path__ + "static/media/pen-black.c7a5277b.svg";